export default "__VITE_ASSET__c9dfc4c2__"